export default __webpack_public_path__ + "img/noticias.7dce43f7.svg";